// icons
import { MdLocalShipping, MdAssignment, MdAddCircle, MdAssessment, MdArchive, MdAttachMoney, MdPostAdd } from "react-icons/md";

const ordenesServicio = {
  id: 'ordenes-servicio-group',
  type: 'group',
  roles: [1, 100, 110, 200],
  breadcrumbs: false,
  children: [
    {
      id: 'ordenes-servicio',
      title: "Servicios",
      type: 'collapse',
      icon: MdLocalShipping,
      children: [
        {
          id: 'ordenes-pendientes',
          title: "Órdenes Pendientes",
          type: 'item',
          breadcrumbs: false,
          icon: MdAssignment,
          url: '/ordenes-servicio/ordenes-pendientes'
        },
        {
          id: 'ordenes-completadas',
          title: "Órdenes Completadas",
          type: 'item',
          breadcrumbs: false,
          icon: MdAssignment,
          url: '/ordenes-servicio/ordenes-completadas'
        },
        {
          id: 'reporte-servicio-form',
          title: "Crear Reporte de Servicio",
          type: 'item',
          roles: [1, 200],
          breadcrumbs: false,
          icon: MdPostAdd,
          url: '/ordenes-servicio/reporte-servicio-form'
        },
        {
          id: 'reportes-servicios',
          title: "Reportes de Servicios",
          type: 'item',
          breadcrumbs: false,
          icon: MdAssessment,
          url: '/ordenes-servicio/reportes-servicios'
        },
        {
          id: 'servicios-refuerzo',
          title: "Servicios de Refuerzo",
          type: 'item',
          breadcrumbs: false,
          icon: MdAddCircle,
          roles: [1, 100, 110],
          url: '/ordenes-servicio/servicios-refuerzo'
        },
        {
          id: 'historial-servicios-refuerzo',
          title: "Historial de Servicios de Refuerzo",
          type: 'item',
          breadcrumbs: false,
          icon: MdArchive,
          roles: [1, 100, 110],
          url: '/ordenes-servicio/historial-servicios-refuerzo'
        }
      ]
    }
  ]
};

export default ordenesServicio;
